import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Header , Image , Popup } from 'semantic-ui-react';
import ThemeColorSetting from '../../constants/themeColor';
import googlePlayStoreBadges from '../../assets/home/google-play-badge.png';
import appStoreBadges from '../../assets/home/app-store.svg';
import androidDevice from '../../assets/androidDevice.gif';
import iPhoneDevice from '../../assets/iPhoneDevice.gif';
import bubbleGraph from '../../assets/pattern/bubbles.svg';

const styles = {
  coverContainer : {
    backgroundColor : ThemeColorSetting.black,
    backgroundImage: 'url(' +bubbleGraph+ ')',
		backgroundSize : '100px 100px',
		backgroundRepeat : 'repeat',
    padding : '80px 0px'
  },
  descriptionWrapper : {
    display : 'flex' ,
    flexDirection : 'column',
    justifyContent : 'center',
    padding : '5vh'
  },
  description : {
    fontSize : '20px',
    color : ThemeColorSetting.white,
    lineHeight: '200%'
  },
  imageWrapper : {
    display : 'flex' ,
    flexDirection : 'row',
    alignItems : 'center' ,
    justifyContent : 'center'
  },
  header : {
    color : ThemeColorSetting.white,
    fontSize : '50px'
  },
  androidDevice : {
    width : '50%',
    height : '100%',
    display : 'flex',
    alignItems : 'center',
    justifyContent : 'center',
  },
  iPhoneDevice : {
    width : '50%',
    height : '100%',
    display : 'flex',
    alignItems : 'center',
    justifyContent : 'center'
  },
  image : {
    width : '80%'
  }
}

class DevicePitch extends Component {
  componentDidMount(){
    const { mixpanel } = this.props;
    mixpanel.track_links("#app_download_google", "Pitch Page", { action : 'download app', platform : "android" });
    mixpanel.track_links("#app_download_ios", "Pitch Page", { action : 'download app', platform : "ios" });
  }
  render() {
    const { string } = this.props;
    return(
      <Grid.Row columns='2' style={styles.coverContainer}>
        <Grid.Column style={styles.imageWrapper}>
          <div style={styles.androidDevice}>
            <Image src={androidDevice} style={styles.image}/>
          </div>
          <div style={styles.iPhoneDevice}>
            <Image src={iPhoneDevice} style={styles.image}/>
          </div>
        </Grid.Column>
        <Grid.Column style={styles.descriptionWrapper}>
          <Header as='h1' style={styles.header}>{string['pich1Header']}</Header>
          <p style={styles.description}>{string['pitch1Content']}</p>
          <div style={{ display : 'flex' , flexDirection : 'row' , alignItems : 'ceneter' }}>
            <a id="app_download_google" href={string['googlePlayStoreUrl']}><Image src={googlePlayStoreBadges} style={{ height : '40px' , marginRight : '10px' }}/></a>
            <a id="app_download_ios" href={string['iosAppStoreUrl']}><Image src={appStoreBadges}/></a>
          </div>
        </Grid.Column>
      </Grid.Row>
    )
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string,
    mixpanel : state.ui.tempData.mixpanel
  }
}

export default connect(mapStateToProps,null)(DevicePitch)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/devicePitch.js
 **/